import { useEffect, useRef, useState } from "react";
import { Landmark } from "lucide-react";
import { useNetWorth, formatINR, shortINR } from "@/context/NetWorthContext";
import { t, getLang } from "@/lib/i18n";

const useCountUp = (target) => {
  const [v, setV] = useState(0);
  const raf = useRef(0);
  useEffect(() => {
    const start = performance.now();
    const tick = (now) => {
      const k = Math.min(1, (now - start) / 1400);
      setV(target * (1 - Math.pow(1 - k, 3)));
      if (k < 1) raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [target]);
  return v;
};

export const FamilyWealth = () => {
  const { total } = useNetWorth();
  const v = useCountUp(total?.total || 0);
  if (!total) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pt-6" data-testid="family-networth-total">
      <div className="relative overflow-hidden rounded-3xl bg-[#1E3A2B] text-[#FDFBF7] p-8 sm:p-10 flex flex-col md:flex-row md:items-center gap-6 rise ring-4 ring-[#C59B27]/60 shadow-[0_18px_50px_-20px_rgba(197,155,39,0.8)]">
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#C59B27]/15" />
        <div className="absolute right-24 -bottom-20 w-48 h-48 rounded-full bg-[#D96B43]/15" />
        <span className="w-14 h-14 shrink-0 rounded-2xl bg-[#C59B27]/20 grid place-items-center"><Landmark className="w-7 h-7 text-[#E2BE52]" /></span>
        <div className="relative flex-1">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#E2BE52]">{t("Combined Vats family net worth")}</p>
          <p className="font-serif text-4xl sm:text-5xl font-bold mt-2" data-testid="family-networth-amount">{shortINR(Math.round(v)) || "₹0"}</p>
          <p className="text-sm text-[#FDFBF7]/70 mt-2" data-testid="family-networth-full">{formatINR(total.total || 0)} · {getLang() === "hi" ? `${total.members} में से ${total.counted} ${t("members counted")}` : `${total.counted} of ${total.members} members counted`}</p>
        </div>
        <p className="relative text-sm text-[#FDFBF7]/70 md:max-w-xs">{t("Add yours or a relative's from any profile.")}</p>
      </div>
    </section>
  );
};
